import {derived, writable} from 'svelte/store';

export enum InvestorProfileSteps {
  SELECT = 'select_profile',
  SELECT_TYPE = 'select_profile_type',
  CREATE_INDIVIDUAL = 'create_individual_profile',
  CREATE_JOINT = 'create_joint_profile',
  CREATE_JOINT_SECONDARY = 'create_joint_profile_secondary',
  CREATE_CORPORATION = 'create_corporation_profile',
  CREATE_TRUST = 'create_trust_profile',
  CREATE_MANAGED = 'create_managed_profile',
  EXEMPTION_STATUS = 'exemption_status_form',
}

export const heading = {
  [InvestorProfileSteps.SELECT]: 'Select profile',
  [InvestorProfileSteps.SELECT_TYPE]: 'Select profile type',
  [InvestorProfileSteps.CREATE_INDIVIDUAL]: 'Primary holder',
  [InvestorProfileSteps.CREATE_JOINT]: 'Primary holder',
  [InvestorProfileSteps.CREATE_JOINT_SECONDARY]: 'Secondary holder',
  [InvestorProfileSteps.CREATE_CORPORATION]: 'Corporation',
  [InvestorProfileSteps.EXEMPTION_STATUS]: 'Exemption status',
};

export const description = {
  [InvestorProfileSteps.SELECT]:
    'Use a profile for this order, or create another',
  [InvestorProfileSteps.SELECT_TYPE]: 'What entity will this new profile be?',
  [InvestorProfileSteps.CREATE_INDIVIDUAL]:
    'Securities are registered to this individual',
  [InvestorProfileSteps.CREATE_JOINT]:
    'Securities are registered to this individual',
  [InvestorProfileSteps.CREATE_JOINT_SECONDARY]:
    'Securities are shared with this individual',
  [InvestorProfileSteps.CREATE_CORPORATION]:
    'Securities will be registered to this corporation',
  [InvestorProfileSteps.CREATE_TRUST]:
    'Securities will be registered to this trust',
  [InvestorProfileSteps.EXEMPTION_STATUS]:
    'Criteria you meet to be an accredited investor',
};

const stackOfSteps = () => {
  const step = writable<string[]>([InvestorProfileSteps.SELECT]);
  return {
    ...step,
    back: () => {
      step.update(step => {
        step.pop();
        return step;
      });
    },
    push: (next: string) => {
      step.update(step => [...step, next]);
    },
  };
};

export const steps = stackOfSteps();
export const currentStep = derived(steps, $steps => $steps[$steps.length - 1]);
